import React, { ReactElement } from "react";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useUserIdentification } from "Components/Features/CheckPrice/userIdentificationHook";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton/RadioButtonTrueFalse";
import { useTexts } from "Components/TextContext";
import { CarProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductIntro/FormElements/interfaces";
import { showIsCarTrimmed } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/helpers";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { useFormState } from "Store/priceCalculation/priceCalculationHooks";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { useFormikContext } from "formik";
import { CAR_FIND_STEP } from "../../carSteps";
import { isYoungUser } from "../../utils/isYoungUser";
import { CarPriceFormValues } from "../interfaces";

interface Props {
  readonly updatePrices: (field: string, value: string) => void;
}

export const YoungerDriver = ({ updatePrices }: Props): ReactElement | null => {
  const formProps = useFormikContext<CarPriceFormValues>();
  const { getText } = useTexts();
  const introFormValues = useFormState(
    CAR_FIND_STEP.id,
  ) as Required<CarProductIntroFormValues>;

  const { current: user } = useUserIdentification(ProductBackendName.CAR);

  if (isYoungUser(user, formProps.values.carOwnerAge)) {
    return null;
  }

  return (
    <RadioButtonTrueFalse
      name="usedByYoungerDriver"
      id="usedByYoungerDriver"
      label={getText("carform.label.youngdriver")}
      noLabel={getText("carform.optionlabel.youngdriver-no")}
      onChange={(event) => {
        if (isDefined(event)) {
          updatePrices(event.target.name, event.target.value);
        }
        const isHighRiskCar = showIsCarTrimmed(
          introFormValues.brand,
          introFormValues.year,
          user,
          event.target.value as BooleanFormType,
        );
        if (!isHighRiskCar) {
          formProps.setFieldValue("isCarTrimmed", undefined);
        }
      }}
      direction="vertical"
      error={getError("usedByYoungerDriver", formProps)}
      labelPopoverProps={{
        children: <div>{getText("carform.hint.youngdriver")}</div>,
      }}
    />
  );
};
